import request from '@/utils/request'

// 查询签到积分设置列表
export function listSign(query) {
  return request({
    url: '/h5/sign/list',
    method: 'get',
    params: query
  })
}
